module.exports = __webpack_public_path__ + "static/media/sa.731fa188.jpg";